import { IconCode } from "@/assets/icons/geist/IconCode";
import { Text } from "@/components/podkit/typography/Text";
import type { AgentMessageFragmentFileModification } from "@/hooks/use-stream-conversation";
import { type FC } from "react";

export const FragmentFileModification: FC<{
    fragment: AgentMessageFragmentFileModification;
}> = ({ fragment }) => {
    return (
        <div className="flex flex-col overflow-hidden rounded-lg border border-border-base">
            <FragmentFileModificationHeader filePath={fragment.filePath} />
            <pre className="p-2 font-mono text-sm text-content-secondary">
                <code>{fragment.content}</code>
            </pre>
        </div>
    );
};

const FragmentFileModificationHeader: FC<{
    filePath: string;
}> = ({ filePath }) => {
    return (
        <div className="flex items-center gap-2 border-b border-border-base bg-surface-02 p-2">
            <IconCode size="base" className="text-content-secondary" />
            <Text className="truncate text-sm font-bold text-content-secondary">{filePath}</Text>
        </div>
    );
};
